import { render, staticRenderFns } from "./ModalMemoCategoryDetail.vue?vue&type=template&id=0dc20b80&scoped=true"
import script from "./ModalMemoCategoryDetail.vue?vue&type=script&lang=js"
export * from "./ModalMemoCategoryDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dc20b80",
  null
  
)

export default component.exports